import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ridango-vertical-or-separator',
  templateUrl: './vertical-or-separator.component.html',
  styleUrls: ['./vertical-or-separator.component.scss']
})
export class VerticalOrSeparatorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
